module.exports = __webpack_public_path__ + "img/thleft.5b7fe6c6.png";